<template>
  <section class="game-section">
    <div class="section-header">
      <div class="section-title">
        <h2>All Games</h2>
      </div>
    </div>

    <div class="game-grid">
      <GameCard v-for="(game, index) in allGames" :key="index" :title="game" />
    </div>
  </section>
</template>

<script>
import GameCard from "@/components/home/gamesSection/gameCard.vue";

export default {
  name: "AllGames",
  components: { GameCard },
  data() {
    return {
      allGames: [
        "slots",
        "crash",
        "battles",
        "duels",
        "roll",
        "upgrader",
        "blackjack",
        "mines",
        "towers",
      ],
    };
  },
};
</script>

<style scoped>
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  width: 100%;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: white;
}

.game-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
  justify-items: center;
}

@media only screen and (max-width: 1024px) {
  .game-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media only screen and (max-width: 640px) {
  .game-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
